import { CardPaymentStateModel, PaymentDetailsModel } from 'models/Payment';
import { financeConfig } from 'configurations';
import { MAX_DECIMAL_PLACES } from 'helpers';

export class CardPaymentHelper {
    public initializePayment(totalPriceWithTax: number, paymentDetails: PaymentDetailsModel, isReadonlyMaxValue: boolean): CardPaymentStateModel {
        let maxDeposit = totalPriceWithTax;
        let minDeposit = financeConfig.card.minDepositPercent * totalPriceWithTax / 100;

        if (minDeposit < financeConfig.card.minDepositValue) {
            minDeposit = financeConfig.card.minDepositValue;

            if (minDeposit > totalPriceWithTax) {
                minDeposit = totalPriceWithTax;
            }
        }

        const isSavedCardDepositExist = paymentDetails.cashCardDeposit !== 0;

        let initialDeposit = isSavedCardDepositExist
            ? paymentDetails.cashCardDeposit
            : financeConfig.card.sliderStart * totalPriceWithTax / 100;

        const isMaxDepositInSavedState = paymentDetails.cashCardDeposit === paymentDetails.total;
        if (isSavedCardDepositExist && isMaxDepositInSavedState) {
            initialDeposit = maxDeposit;
        }

        if (initialDeposit < minDeposit) {
            initialDeposit = minDeposit;
        }

        if (initialDeposit > maxDeposit) {
            initialDeposit = maxDeposit;
        }

        if (isReadonlyMaxValue) {
            initialDeposit = maxDeposit;
        }

        let paymentData = new CardPaymentStateModel();
        paymentData.deposit = initialDeposit;
        paymentData.maxDeposit = maxDeposit;
        paymentData.minDeposit = minDeposit;
        paymentData.isReadonlyMaxValue = isReadonlyMaxValue;

        this.setPaymentPersentage(totalPriceWithTax, paymentData);
        this.setPaymentPriceLeftToPay(totalPriceWithTax, paymentData);

        return paymentData;
    }

    public updatePayment(totalPriceWithTax: number, paymentData: CardPaymentStateModel, deposit: number): CardPaymentStateModel {
        paymentData = { ...paymentData };

        paymentData.deposit = deposit;

        this.setPaymentPersentage(totalPriceWithTax, paymentData);
        this.setPaymentPriceLeftToPay(totalPriceWithTax, paymentData);

        return paymentData;
    }

    public incrementPayment(totalPriceWithTax: number, paymentData: CardPaymentStateModel): CardPaymentStateModel {
        paymentData = { ...paymentData };

        if (paymentData.deposit < paymentData.maxDeposit) {
            paymentData.deposit += financeConfig.card.sliderIncrement;

            if (paymentData.deposit > paymentData.maxDeposit) {
                paymentData.deposit = paymentData.maxDeposit;
            }
        }

        this.setPaymentPersentage(totalPriceWithTax, paymentData);
        this.setPaymentPriceLeftToPay(totalPriceWithTax, paymentData);

        return paymentData;
    }

    public decrementPayment(totalPriceWithTax: number, paymentData: CardPaymentStateModel): CardPaymentStateModel {
        paymentData = { ...paymentData };

        if (paymentData.deposit > paymentData.minDeposit) {
            paymentData.deposit -= financeConfig.card.sliderIncrement;

            if (paymentData.deposit < paymentData.minDeposit) {
                paymentData.deposit = paymentData.minDeposit;
            }
        }

        this.setPaymentPersentage(totalPriceWithTax, paymentData);
        this.setPaymentPriceLeftToPay(totalPriceWithTax, paymentData);

        return paymentData;
    }

    private setPaymentPersentage(totalPriceWithTax: number, paymentData: CardPaymentStateModel): void {
        paymentData.percentage = Number((paymentData.deposit * 100 / totalPriceWithTax).toFixed(MAX_DECIMAL_PLACES));
    }

    private setPaymentPriceLeftToPay(totalPriceWithTax: number, paymentData: CardPaymentStateModel): void {
        paymentData.amountLeft = totalPriceWithTax - paymentData.deposit;
    }
}

export const cardPaymentHelper = new CardPaymentHelper();